import { VStack } from "@gluestack-ui/themed";
import { ConfirmPaymentController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { Button } from "@repo/core/components/core/Button";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types";
import {
  formatDateTime,
  formatDateTimeString
} from "@repo/core/utils/date.utils";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ConfirmCardPassword } from "@repo/core/components/layout/ConfirmPassword";
import Spinner from "@repo/core/components/core/Spinner";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const ConfirmPayment = () => {
  const {
    isMobile,
    back,
    handleConfirmCardPassword,
    alertModalRef,
    alertOptions,
    isValidatingPassword,
    receiptData
  } = ConfirmPaymentController();
  return (
    <Scaffolds.Root
      title="Confirmar Pagamento"
      statusBarVariant={StatusBarVariantEnum.LIGHT}
      minHeight="$100vh"
    >
      <Scaffolds.Form
        showHeader={false}
        footerContent={
          <VStack
            flex={1}
            w="$full"
            gap="$4"
            pb={isMobile ? "$4" : "$12"}
            px="$4"
            pt="$4"
            justifyContent="flex-end"
          >
            <Button
              text="Cancelar"
              action="negative"
              variant="outline"
              onPress={back}
            />
          </VStack>
        }
      >
        <ConfirmCardPassword
          handleConfirmCardPassword={handleConfirmCardPassword}
        />

        {isValidatingPassword && <Spinner size={32} my="$2" />}
      </Scaffolds.Form>
      <AlertModal
        ref={alertModalRef}
        title="Transação realizada"
        variant={AlertModalVariant.success}
        options={alertOptions}
      >
        <VStack alignItems="center" justifyContent="center" gap="$2">
          <Text fontWeight={600} textAlign="center">
            {receiptData?.lojista}
          </Text>
          <Text fontWeight={600} textAlign="center">
            {numberToBrl(parseFloat(receiptData?.valor || ""))}
          </Text>
          <Text fontSize="$sm" textAlign="center">
            {formatDateTimeString(
              formatDateTime(receiptData?.data, receiptData?.hora)
            )}
          </Text>
        </VStack>
      </AlertModal>
    </Scaffolds.Root>
  );
};
export default ConfirmPayment;
